import styled, { css } from "styled-components";

const DropdownWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
	transform: rotate(0deg);
	height: 40px;
	padding: 5px 10px 5px 15px;
	align-self: stretch;
	max-width: 100px;
	min-width: 100px;
	justify-content: space-between;
	background: rgba(0, 0, 0, 0.9);
	border-radius: 25px;
	cursor: pointer;

	@media (min-width: 375px) {
		max-width: 150px;
		min-width: 150px;
	}

	@media (min-width: 425px) {
		max-width: 180px;
		min-width: 180px;
	}

	svg {
		width: 20px;
		height: 20px;
	}

	${({ rotate }) =>
		rotate &&
		css`
			svg {
				&:last-of-type {
					transform: rotate(180deg);
					animation: rotate 0.1s;
				}
			}
		`}

	${({ isDropdownOpen }) =>
		isDropdownOpen &&
		css`
			display: flex;
			height: 40px;
			padding: 5px 10px 5px 15px;
			align-items: center;
			gap: 5px;
			align-self: stretch;
			border-radius: 20px 20px 0 0;
			background: linear-gradient(0deg, #191726 0%, #050512 100%);
			box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
			backdrop-filter: blur(15px);
		`}
`;

const HeaderText = styled.div`
	display: block;
	color: var(--secondary-text-color);
	font-size: 12px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0.3px;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	max-width: 45px;
	min-width: 45px;

	@media (min-width: 375px) {
		max-width: 100px;
		min-width: 100px;
	}

	@media (min-width: 425px) {
		max-width: 130px;
		min-width: 130px;
	}
`;

const StyledMenu = styled.div`
	list-style: none;
	display: flex;
	flex-direction: column;
	color: var(--main-secondary-text-color);
	max-width: 100px;
	min-width: 100px;
	opacity: 1;
	position: absolute;
	z-index: 999;
	border-radius: 0 0 20px 20px;
	background: var(--modal-bg);
	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
	backdrop-filter: blur(15px);
	font-size: 12px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0.3px;

	@media (min-width: 375px) {
		max-width: 150px;
		min-width: 150px;
	}

	@media (min-width: 425px) {
		max-width: 180px;
		min-width: 180px;
	}
`;

const StyledMenuItem = styled.div`
	display: flex;
	height: 40px;
	padding: 5px 10px 5px 15px;
	align-items: center;
	gap: 5px;
	align-self: stretch;
	cursor: pointer;

	svg {
		width: 20px;
		height: 20px;

		path {
			fill: var(--main-secondary-text-color);
		}
	}
`;

export { DropdownWrapper, HeaderText, StyledMenu, StyledMenuItem };
